<template>
  <div v-loading="isLoading">
    <el-card shadow="never">
      <Tracking
        ref="tracking"
        :form-data="carrier"
      />
    </el-card>
  </div>
</template>
<script>
import Tracking from '@/components/Application/Manage/Carriers/Carrier/Tracking'
export default {
  components: {
    Tracking
  },
  data () {
    return {
      title: 'Tracking',
      breadcrumb: {
        name: 'Tracking',
        route: { name: 'manage-carriers-carrier-configurations-tracking' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: {}
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, builder => {
        builder.include = ['tracking_connection', 'edi_connection']
      }).then(res => { this.carrier = res })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.update()
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
        })
    }
  }
}
</script>
